<template>
  <div class="media">
    <v-row>
      <v-col class="text-right">
        <v-icon @click="handleOpenMediaDialog(false, {})">mdi-plus</v-icon>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="mediaList"
      :items-per-page="-1"
      :hide-default-footer="true"
      :header-props="{ sortIcon: null }"
    >
      <template v-slot:item="row">
        <tr>
          <td>{{row.item.mediaId}}</td>
          <td>{{row.item.mediaName}}</td>
          <td>
            <img :src="row.item.mediaLogo"/>
          </td>
          <td>
            <button @click="handleOpenMediaDialog(true, row.item)">
              <v-icon>mdi-lead-pencil</v-icon>
            </button>
          </td>
          <td>
            <button @click.stop="handleDelete(row.item)">
              <v-icon>mdi-window-close</v-icon>
            </button>
          </td>
        </tr>
      </template>
    </v-data-table>
    <Dialog :title="isEdit ? '修改媒體': '新增媒體'" :isVisible="isMediaDialogVisible" @ok="handleSubmitMedia" @cancel="handleCloseDialog">
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field label="名稱" v-model="media.mediaName" :rules="nameRules"/>
          <v-row align="center">
            <v-col md="9">
              <v-file-input
                :rules="fileRules"
                @change="handleChangeLogo"
                @click:clear="hanfleClearImage"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="上傳 Logo"
                label="logo"
                ref="imageFileInput"
              />
            </v-col>
            <v-col md="3">
              <img :src="mediaImg"/>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </dialog>
  </div>
</template>

<script>
import Dialog from '@/components/Dialog.vue';
import api from '@/api';
import ruleMixin from '@/minix/ruleMixin';
import imageConvert from '@/utils/image';
import Swal from 'sweetalert2';

export default {
  mixins: [ruleMixin],
  components: {
    Dialog,
  },
  data() {
    return {
      valid: true,
      isMediaDialogVisible: false,
      isEdit: false,
      mediaImg: '',
      media: {
        mediaId: '',
        mediaLogo: '',
        mediaName: '',
      },
      deleteId: '',
      headers: [
        { text: 'ID', value: 'mediaId' },
        { text: '媒體', value: 'mediaName' },
        { text: 'Logo', value: 'mediaLogo' },
        { text: '修改', value: 'edit' },
        { text: '刪除', value: 'delete' },
      ],
      mediaList: [],
      nameRules: this.requiredRule('名稱'),
    };
  },
  computed: {
    fileRules() {
      return [
        (v) => !!v || !!this.mediaImg || '檔案 為必填',
        (v) => !v || v.size < 4000000 || '照片大小不可大於 4 MB!',
      ];
    },
  },
  methods: {
    handleChangeLogo(event) {
      if (event) {
        this.media.mediaLogo = event;
        this.mediaImg = URL.createObjectURL(event);
      }
    },
    handleCloseDialog() {
      this.isMediaDialogVisible = false;
      this.$refs.imageFileInput.clearableCallback();
      this.mediaImg = '';
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
    },
    handleOpenMediaDialog(isEdit, {
      mediaId, mediaLogo, mediaName,
    }) {
      this.media = {
        mediaId,
        mediaLogo,
        mediaName,
      };
      if (mediaLogo) {
        this.mediaImg = mediaLogo;
      }
      this.isEdit = isEdit;
      this.isMediaDialogVisible = true;
    },
    async handleSubmitMedia() {
      if (!this.$refs.form.validate()) return;
      const data = { ...this.media };
      const { mediaLogo } = this.media;
      data.mediaLogo = await imageConvert(mediaLogo);

      const { status } = this.isEdit
        ? await api.media.edit(data)
        : await api.media.add(data);

      if (status === 1) {
        await this.getMediaList();
        this.handleCloseDialog();
      }
    },
    async handleDelete(item) {
      const { mediaId } = item;
      await Swal.fire(
        {
          title: '確定要刪除此媒體嗎?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        },
      ).then(async (result) => {
        if (result.isConfirmed) {
          const { status } = await api.media.delete(mediaId);
          if (status === 1) {
            await Swal.fire({ icon: 'success', title: '刪除成功' });
            await this.getMediaList();
          } else {
            await Swal.fire({ icon: 'warning', title: '刪除失敗，請聯繫系統管理員。' });
          }
        }
      });
    },
    hanfleClearImage() {
      this.mediaImg = '';
    },
    async getMediaList() {
      const { data } = await api.media.mediaList();
      this.mediaList = data;
    },
  },
  mounted() {
    this.getMediaList();
  },
};
</script>
<style scoped lang="scss">
.media {
  table {
    img {
      width: 64px;
      height: auto;
    }
  }
}
</style>
